(function(){'use strict';function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }
  return object;
}
function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get.bind();
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get.apply(this, arguments);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}customElements.get("quick-add-modal")||customElements.define("quick-add-modal",function(e){_inherits(r,e);var t=_createSuper(r);function r(){var e;return _classCallCheck(this,r),(e=t.call(this)).modalContent=e.querySelector('[id^="QuickAddInfo-"]'),e}return _createClass(r,[{key:"hide",value:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],t=document.querySelector("cart-notification")||document.querySelector("cart-drawer");t&&t.setActiveElement(this.openedBy),this.modalContent.innerHTML="",e&&(this.openedBy=null),_get(_getPrototypeOf(r.prototype),"hide",this).call(this);}},{key:"show",value:function(e){var t=this;e.setAttribute("aria-disabled",!0),e.classList.add("loading"),e.querySelector(".loading-overlay__spinner").classList.remove("hidden"),fetch(e.getAttribute("data-product-url")).then((function(e){return e.text()})).then((function(o){var i=(new DOMParser).parseFromString(o,"text/html");t.productElement=i.querySelector('section[id^="MainProduct-"]'),t.preventDuplicatedIDs(),t.removeDOMElements(),t.setInnerHTML(t.modalContent,t.productElement.innerHTML),window.Shopify&&Shopify.PaymentButton&&Shopify.PaymentButton.init(),window.ProductModel&&window.ProductModel.loadShopifyXR(),t.removeGalleryListSemantic(),t.updateImageSizes(),t.preventVariantURLSwitching(),_get(_getPrototypeOf(r.prototype),"show",t).call(t,e);})).finally((function(){e.removeAttribute("aria-disabled"),e.classList.remove("loading"),e.querySelector(".loading-overlay__spinner").classList.add("hidden");}));}},{key:"setInnerHTML",value:function(e,t){e.innerHTML=t,e.querySelectorAll("script").forEach((function(e){var t=document.createElement("script");Array.from(e.attributes).forEach((function(e){t.setAttribute(e.name,e.value);})),t.appendChild(document.createTextNode(e.innerHTML)),e.parentNode.replaceChild(t,e);}));}},{key:"preventVariantURLSwitching",value:function(){var e=this.modalContent.querySelector("variant-radios,variant-selects");e&&e.setAttribute("data-update-url","false");}},{key:"removeDOMElements",value:function(){var e=this.productElement.querySelector("pickup-availability");e&&e.remove();var t=this.productElement.querySelector("product-modal");t&&t.remove();var r=this.productElement.querySelectorAll("modal-dialog");r&&r.forEach((function(e){return e.remove()}));}},{key:"preventDuplicatedIDs",value:function(){var e=this.productElement.dataset.section;this.productElement.innerHTML=this.productElement.innerHTML.replaceAll(e,"quickadd-".concat(e)),this.productElement.querySelectorAll("variant-selects, variant-radios, product-info").forEach((function(t){t.dataset.originalSection=e;}));}},{key:"removeGalleryListSemantic",value:function(){var e=this.modalContent.querySelector('[id^="Slider-Gallery"]');e&&(e.setAttribute("role","presentation"),e.querySelectorAll('[id^="Slide-"]').forEach((function(e){return e.setAttribute("role","presentation")})));}},{key:"updateImageSizes",value:function(){var e=this.modalContent.querySelector(".product");if(e.classList.contains("product--columns")){var t=e.querySelectorAll(".product__media img");if(t.length){var r="(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";e.classList.contains("product--medium")?r=r.replace("715px","605px"):e.classList.contains("product--small")&&(r=r.replace("715px","495px")),t.forEach((function(e){return e.setAttribute("sizes",r)}));}}}}]),r}(ModalDialog));})();